import { ResponsiveHeading } from 'component-library/components/typography/ResponsiveHeading';
import { colors } from 'component-library/styles/colors';
import { WrapperLarge } from 'page-components/about-us/shared/WrapperLarge';
import React, { FC } from 'react';
import styled from 'styled-components';

import { FeaturesSectionProps } from '.';
import { Alignment, FeatureSection } from './FeatureSection';
import { SECTIONS } from './utils';

const FeaturesSectionWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 40px;
  grid-row-gap: 40px;
  .section1 {
    grid-area: 1 / 1 / 2 / 2;
  }
  .section2 {
    grid-area: 2 / 1 / 3 / 2;
  }
  .section3 {
    grid-area: 1 / 2 / 3 / 3;
  }
`;

export interface FeatureSectionProps {
  heading: string;
  body: string;
}

export const FeaturesSectionLarge: FC<FeaturesSectionProps> = ({
  heading,
  topSection,
  sections,
}) => (
  <WrapperLarge maxWidth={1568} spacing={80}>
    <ResponsiveHeading marginBottom={80} variant={2}>
      {heading}
    </ResponsiveHeading>
    {topSection && (
      <FeatureSection
        {...topSection}
        backgroundColor={colors.teal}
        alignment={Alignment.Row}
        marginBottom={40}
      />
    )}
    <FeaturesSectionWrapper>
      {sections.map((section, idx) => (
        <FeatureSection
          key={idx}
          {...section}
          alignment={Alignment.Column}
          backgroundColor={SECTIONS[(idx + 1) as 1 | 2 | 3]}
          className={`section${idx + 1}`}
        />
      ))}
    </FeaturesSectionWrapper>
  </WrapperLarge>
);
